module.exports = __webpack_public_path__ + "a6a485fe0bd123bf04eab9e5a379a6bf.webp";